import gql from "graphql-tag";

export const GET_REPORT_GROUPS_LIST = gql`
	query getReportGroupsList {
		reportGroups {
			group
			reports {
				id
				title
				description
				filters
			}
		}
	}
`;

export const GET_REPORT_FILTERS = gql`
	query getReportFilters {
		reportFilters {
			allowedMonths
			filters {
				field
				valueForDisplay
				type
				values {
					value
					valueForDisplay
				}
			}
		}
	}
`;

export const GET_BRAND_LOCATIONS = gql`
	query getBrandLocations($brandIds: [Int]!) {
		reportStoresList(brandIds: $brandIds) {
			bizLocationId
			bizLocationNickname
			brandId
		}
	}
`;

export const GENERATE_REPORT = gql`
	mutation generateReport($input: GenerateReportInput) {
		generateReport(input: $input) {
			status {
				success
				messages {
					field
					message
				}
			}
		}
	}
`;
